<template>
  <el-container style="height: 100vh">
    <el-aside :width="isCollapse ? '64px' : '220px'" style="background-color: #304156; transition: width 0.3s">
      <div style="height: 60px; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 18px; font-weight: bold; white-space: nowrap; overflow: hidden">
        <span v-show="!isCollapse">直播平台管理后台</span>
        <span v-show="isCollapse">直播</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        :collapse="isCollapse"
        router
      >
        <menu-tree v-if="menus.length" :menus="menus"></menu-tree>
        <template v-else>
          <el-menu-item index="/dashboard">
            <i class="el-icon-s-home"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <el-menu-item index="/user">
            <i class="el-icon-user-solid"></i>
            <span slot="title">用户管理</span>
          </el-menu-item>
          <el-menu-item index="/channel">
            <i class="el-icon-s-platform"></i>
            <span slot="title">频道管理</span>
          </el-menu-item>
          <el-menu-item index="/gift">
            <i class="el-icon-present"></i>
            <span slot="title">礼物管理</span>
          </el-menu-item>
          <el-submenu index="live">
            <template slot="title">
              <i class="el-icon-video-camera"></i>
              <span>直播管理</span>
            </template>
            <el-menu-item index="/course">课程管理</el-menu-item>
            <el-menu-item index="/live-room">直播间</el-menu-item>
            <el-menu-item index="/question-bank">题库管理</el-menu-item>
            <el-menu-item index="/exam-record">考试记录</el-menu-item>
            <el-menu-item index="/exam-manage">考试管理</el-menu-item>
          </el-submenu>
          <el-submenu index="settings">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span>系统设置</span>
            </template>
            <el-menu-item index="/settings/member">会员设置</el-menu-item>
            <el-menu-item index="/settings/system">系统设置</el-menu-item>
          </el-submenu>
          <el-menu-item index="/log">
            <i class="el-icon-document"></i>
            <span slot="title">日志管理</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header style="display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #eee; background: #fff">
        <div style="display: flex; align-items: center">
          <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" style="font-size: 20px; cursor: pointer" @click="isCollapse = !isCollapse"></i>
          <span style="margin-left: 15px; font-size: 16px; font-weight: 500">{{ $route.meta.title || '首页' }}</span>
        </div>
        <div style="display: flex; align-items: center">
          <router-link to="/personal" class="header-user" title="个人信息">
            <img v-if="adminAvatar" :src="adminAvatar" class="header-avatar" alt="">
            <i v-else class="el-icon-user-solid header-avatar header-avatar--empty"></i>
            <span class="header-name">{{ adminName }}</span>
          </router-link>
          <el-button type="text" @click="handleLogout">退出登录</el-button>
        </div>
      </el-header>
      <el-main style="background: #f5f7f9; padding: 20px">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import MenuTree from './MenuTree.vue'
import { getMyMenuTree } from '../api'
import { getUserInfo, setUserInfo, clearAuth } from '../utils/auth'

export default {
  name: 'Layout',
  components: { MenuTree },
  data() {
    return {
      isCollapse: false,
      adminName: '',
      adminAvatar: '',
      menus: []
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    }
  },
  created() {
    const userInfo = getUserInfo()
    this.adminName = userInfo.nickname || userInfo.username || '管理员'
    this.adminAvatar = userInfo.avatar || ''
    if (userInfo.menus && userInfo.menus.length) {
      this.menus = userInfo.menus
    } else {
      this.loadMenus()
    }
    this.$root.$on('profile-updated', this.onProfileUpdated)
  },
  beforeDestroy() {
    this.$root.$off('profile-updated', this.onProfileUpdated)
  },
  methods: {
    onProfileUpdated(info) {
      if (info.nickname) this.adminName = info.nickname
      if (info.avatar !== undefined) this.adminAvatar = info.avatar
    },
    async loadMenus() {
      try {
        const res = await getMyMenuTree()
        this.menus = res.data || []
        const userInfo = getUserInfo()
        userInfo.menus = this.menus
        setUserInfo(userInfo)
      } catch (e) {
        this.menus = []
      }
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearAuth()
        this.$router.push('/login')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.header-user {
  display: flex;
  align-items: center;
  margin-right: 16px;
  text-decoration: none;
  color: #606266;
  cursor: pointer;
}
.header-user:hover .header-name {
  color: #409eff;
}
.header-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 8px;
  border: 1px solid #ebeef5;
}
.header-avatar--empty {
  line-height: 32px;
  text-align: center;
  font-size: 18px;
  color: #c0c4cc;
  border: 1px dashed #dcdfe6;
}
.header-name {
  font-size: 14px;
}
</style>
